import { Button, Classes, Dialog, Pre } from '@blueprintjs/core';
import * as React from 'react';

interface InspectorButtonProps {
  content: object;
}

interface InspectorButtonState {
  show: boolean;
}

class InspectorButton extends React.Component<
  InspectorButtonProps,
  InspectorButtonState
> {
  public state = {
    show: false,
  };

  public render() {
    const { content } = this.props;
    const { show } = this.state;

    if (process.env.NODE_ENV === 'development') {
      return (
        <>
          <Button intent="warning" onClick={this.toggleShow}>
            json
          </Button>
          <Dialog
            canEscapeKeyClose={true}
            canOutsideClickClose={true}
            isCloseButtonShown={true}
            isOpen={show}
            onClose={this.toggleShow}
            title="check-in json">
            <div className={Classes.DIALOG_BODY}>
              <Pre style={{ overflowX: 'scroll' }}>
                {JSON.stringify(content, null, 2)}
              </Pre>
            </div>
          </Dialog>
        </>
      );
    } else {
      return null;
    }
  }
  private toggleShow = () => this.setState(({ show }) => ({ show: !show }));
}

export default InspectorButton;



// WEBPACK FOOTER //
// ./src/components/InspectorButton.tsx